import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('mapBoundaryPopover');

    return {
        DELETE: t('delete'),
        RENAME: t('rename')
    };
};

export default useTranslation;
